import { notes } from 'utils/middleware/notes'
import { user } from './user'

export const appMiddleware = [notes, user]
